/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { User, UserService } from '@administration-client/user-shared';
import { StateResource } from '@common/tech-shared';
import { AsyncPipe } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { UserListComponent } from './user-list/user-list.component';

@Component({
  selector: 'administration-user-list-container',
  imports: [UserListComponent, AsyncPipe],
  templateUrl: './user-list-container.component.html',
})
export class UserListContainerComponent implements OnInit, OnDestroy {
  private readonly userService = inject(UserService);

  public usersStateResource$: Observable<StateResource<User[]>>;

  ngOnInit(): void {
    this.usersStateResource$ = this.userService.getAll();
  }

  ngOnDestroy(): void {
    this.userService.refresh();
  }
}
